// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.MultipleFileUpload_dashboard__njcEY {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px 30px 80px 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
}

.MultipleFileUpload_dashboardContain__diOti {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_dashboardContain__diOti,
.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_dashboard__njcEY,
.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_cont2__AAQ9g {
  background-Color: #0f1824;
}

.MultipleFileUpload_top_header__Py0I0 .MultipleFileUpload_top_header_inner__ju1dR {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.MultipleFileUpload_cont2__AAQ9g {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.MultipleFileUpload_subLink__-1y60 svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.MultipleFileUpload_footer__BFGYL {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.MultipleFileUpload_bodythemelight__55up6 {
  background-color: #fff;
  padding-top: 90px;
}

.MultipleFileUpload_bodythemedark__nDQcj {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.MultipleFileUpload_headerthemelight__MXEfp {
  background-color: #fff;
}

.MultipleFileUpload_headerthemedark__zXZOl {
  background-color: #132337;
}

.MultipleFileUpload_top_header__Py0I0 {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
}

/* 
LEFT MENU THEME CHANGE
*/
.MultipleFileUpload_menuthemelight__7BXMU {
  background-color: #fff;
}

.MultipleFileUpload_menuthemedark__rwp8J {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.MultipleFileUpload_menulinklight__wFWRF span {
  color: #666666 !important;
}

.MultipleFileUpload_menulinklight__wFWRF a {
  color: #CBCBCB !important;
}

.MultipleFileUpload_menulinklight__wFWRF:hover span, .MultipleFileUpload_menulinklight__wFWRF:hover a {
  color: #fff !important;
}

.MultipleFileUpload_menulinkdarkSelected__m3AHn {
  background-color: #1c2e45;
  color: #fff;
}

.MultipleFileUpload_menuthemelight__7BXMU .MultipleFileUpload_menulinklightSelected__D7TQn {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #205440;
}

.MultipleFileUpload_menulinkdark__Q6evH {
  color: #60677e !important;
}

.MultipleFileUpload_menulinklight__wFWRF:hover {
  color: #fff !important;
  background-color: #205440;
}

.MultipleFileUpload_menulinkdark__Q6evH:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.MultipleFileUpload_headinglight__EKOr6 {
  color: #60677e;
}

.MultipleFileUpload_headingdark__qVnHy {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.MultipleFileUpload_searchboxlight__RYStC {
  background-color: #fff;
  border: none;
}

.MultipleFileUpload_searchboxdark__ATbCI {
  background-color: #132337;
  color: #fff;
  border: none;
}

.MultipleFileUpload_searchboxdark__ATbCI::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.MultipleFileUpload_tableheadlight__IICSt {
  background-color: #205440;
  border-radius: 5px 5px 0px 0px;
}

.MultipleFileUpload_tableheadlight__IICSt th {
  color: #fff;
}

thead .MultipleFileUpload_tableheadlight__IICSt th:first-child,
thead .MultipleFileUpload_tableheaddark__uDmqr th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .MultipleFileUpload_tableheadlight__IICSt th:last-child,
thead .MultipleFileUpload_tableheaddark__uDmqr th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.MultipleFileUpload_table__tyXPa.MultipleFileUpload_table-borderless__aRKlG {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.MultipleFileUpload_tableheaddark__uDmqr {
  background-color: #1e1e2d;
  color: #fff;
}

.MultipleFileUpload_table-borderless__aRKlG tr:nth-child(even) {
  background-color: #F9FAFB;
}

.MultipleFileUpload_table-borderless__aRKlG .MultipleFileUpload_left-section__ZDD\\+g {
  padding-top: 10px;
}

.MultipleFileUpload_tablebodylight__\\+2kEF td,
.MultipleFileUpload_tablebodydark__OQqHb td {
  padding: 1rem 1rem !important;
}

.MultipleFileUpload_tablebodylight__\\+2kEF {
  background-color: #fff;
}
.MultipleFileUpload_tablebodylight__\\+2kEF:hover {
  background-color: #ddecf9;
  cursor: pointer;
}

.MultipleFileUpload_tablebodydark__OQqHb {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.MultipleFileUpload_tablebodydark__OQqHb:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.MultipleFileUpload_paginationlight__suIRL {
  color: #60677e !important;
  font-size: 13px !important;
}

.MultipleFileUpload_paginationdark__z0Qbk {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.MultipleFileUpload_formthemelight__cDiE- {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.MultipleFileUpload_formthemedark__4dyQi {
  background-color: #1e1e2d;
  color: #60677e !important;
  font-size: 14px;
}
.MultipleFileUpload_formthemedark__4dyQi ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.MultipleFileUpload_viewformlight__LkUc8 {
  background-color: #f3f6f9;
}

.MultipleFileUpload_permissionboxlight__pZ\\+zL {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.MultipleFileUpload_permissionboxdark__6GAme {
  background-color: #151521;
  border: solid 1px #242434;
}

.MultipleFileUpload_errormsgclr__cG9yB {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.MultipleFileUpload_graphclrlight__n2Sr4 {
  background-color: #fff;
}

.MultipleFileUpload_graphclrdark__2W8YW {
  background-color: #1e1e2d;
}

/* 
Counter theme
*/
#MultipleFileUpload_card1bglight__C3eeB {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#MultipleFileUpload_card1bglight__C3eeB:hover {
  background: #f7fffc;
}

#MultipleFileUpload_card1bgdark__A\\+GqH {
  background: #392f28;
}

#MultipleFileUpload_card1bgdark__A\\+GqH:hover {
  background: #f7fffc;
}

#MultipleFileUpload_card2bglight__o-SOh {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#MultipleFileUpload_card2bglight__o-SOh:hover {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #f7fffc;
}

#MultipleFileUpload_card2bgdark__J\\+NKA {
  background: #1c3238;
}

#MultipleFileUpload_card3bglight__1SGnR {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#MultipleFileUpload_card3bglight__1SGnR:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#MultipleFileUpload_card3bgdark__X-HBK {
  background: #3a2434;
}

#MultipleFileUpload_card4bglight__1\\+fiS {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#MultipleFileUpload_card4bglight__1\\+fiS:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#MultipleFileUpload_card4bgdark__VCeGa {
  background: #2f264f;
}

#MultipleFileUpload_card1bgdark__A\\+GqH a, #MultipleFileUpload_card1bgdark__A\\+GqH p,
#MultipleFileUpload_card2bgdark__J\\+NKA a, #MultipleFileUpload_card2bgdark__J\\+NKA p,
#MultipleFileUpload_card3bgdark__X-HBK a, #MultipleFileUpload_card3bgdark__X-HBK p,
#MultipleFileUpload_card4bgdark__VCeGa a, #MultipleFileUpload_card4bgdark__VCeGa p {
  color: #fff;
}

/* 
Action button theme
*/
.MultipleFileUpload_actionbtnlight__toXE9 {
  color: rgba(70, 71, 91, 0.8705882353);
}

.MultipleFileUpload_actionbtndark__tt7mR {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.MultipleFileUpload_profiledropdownlight__kVfq- {
  background-color: #fff;
}

.MultipleFileUpload_profiledropdowndark__XT0PU {
  background-color: #151521;
}

.MultipleFileUpload_settingsection__wRS3o #MultipleFileUpload_addform__TioPc.MultipleFileUpload_formthemedark__4dyQi .MultipleFileUpload_savebtn__E3H6v {
  background-color: #0a2574;
  color: #fff;
}

#MultipleFileUpload_addform__TioPc.MultipleFileUpload_formthemedark__4dyQi .MultipleFileUpload_savebtn__E3H6v {
  background-color: #0a2574;
  color: #fff;
}

.MultipleFileUpload_profile_conatiner__5MRJz {
  border-radius: 5px !important;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_ag-theme-alpine__dmLs- .MultipleFileUpload_ag-row__jVeoB {
  background: #000 !important;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_formbtn__IMFTv {
  background-color: #0a2574;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_resetbtn__JOibc {
  color: #fff;
  background-color: transparent;
  border: solid 1px #0a2574;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_resetbtn__JOibc:hover {
  background-color: #0a2574;
}

.MultipleFileUpload_headingdark__qVnHy span {
  background-color: #132337;
}

.MultipleFileUpload_resetbtn__JOibc {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #205440;
  color: #205440;
  min-width: 113px;
}

.MultipleFileUpload_resetbtn__JOibc:hover,
.MultipleFileUpload_resetbtn__JOibc:active,
.MultipleFileUpload_resetbtn__JOibc:focus {
  background-color: #205440;
  color: #fff;
}

.MultipleFileUpload_addBtn__XN\\+ey {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.MultipleFileUpload_addBtn__XN\\+ey svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.MultipleFileUpload_addBtn__XN\\+ey:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.MultipleFileUpload_cust_addBtn__mbp2P.MultipleFileUpload_addBtn__XN\\+ey svg {
  top: 2px;
}

.MultipleFileUpload_deleteBtn__Cthuu {
  min-width: auto;
  padding: 10px 0;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.MultipleFileUpload_deleteBtn__Cthuu {
  min-width: auto !important;
  height: 50px !important;
  background-color: #205440 !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
  padding: 0.375rem 1rem !important;
}

.MultipleFileUpload_deleteBtn__Cthuu:active, .MultipleFileUpload_deleteBtn__Cthuu:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.MultipleFileUpload_deleteBtn__Cthuu svg {
  position: relative;
  top: -2px;
}

.MultipleFileUpload_deleteBtn__Cthuu:hover,
.MultipleFileUpload_deleteBtn__Cthuu:active,
.MultipleFileUpload_deleteBtn__Cthuu:focus {
  background-color: #205440 !important;
  color: #fff;
  border: none;
}

.MultipleFileUpload_confirmBtn__Hu73W {
  background-color: #205440;
}

.MultipleFileUpload_confirmBtn__Hu73W:hover,
.MultipleFileUpload_confirmBtn__Hu73W:active,
.MultipleFileUpload_confirmBtn__Hu73W:focus {
  background-color: #205440;
}

.MultipleFileUpload_confirmBtn__Hu73W svg {
  top: 0;
}

.MultipleFileUpload_back_dlt__LqR\\+c {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.MultipleFileUpload_delPopContainer__mSgsh .MultipleFileUpload_modal-body__ZaTVw {
  padding: 25px;
  text-align: center;
}

.MultipleFileUpload_delPopContainer__mSgsh .MultipleFileUpload_delet_icon__rCiDT {
  margin-bottom: 11px;
}

.MultipleFileUpload_delPopContainer__mSgsh p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.MultipleFileUpload_arrowback__uE5pT svg {
  fill: #000;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_arrowback__uE5pT {
  background-color: #0a2574;
  color: #fff;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_arrowback__uE5pT svg {
  fill: #fff;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_drpdwn_btn__FUvyA {
  background-color: #132337;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_empname__N-SE- {
  color: #60677e !important;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_navitemli__UiPob a {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_tabnavli__y6GNL a.MultipleFileUpload_settingsgeneral__7QqqL,
.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_tabnavli__y6GNL a.MultipleFileUpload_settingslinks__tlKBP:hover {
  background-color: #0a2574;
  color: #fff;
}

.MultipleFileUpload_bodythemedark__nDQcj .MultipleFileUpload_tabnavli__y6GNL a.MultipleFileUpload_settingslinks__tlKBP {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

@media only screen and (max-width: 1200px) {
  .MultipleFileUpload_tableheadlight__IICSt th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .MultipleFileUpload_dashboard__njcEY {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  #MultipleFileUpload_dashboardcont2__EknEY {
    height: auto !important;
  }
}
@media only screen and (max-width: 767px) {
  .MultipleFileUpload_sectionright__PRP6W {
    float: unset !important;
  }
  .MultipleFileUpload_dashboard__njcEY {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .MultipleFileUpload_cont2__AAQ9g {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 20px 10px !important;
  }
  .MultipleFileUpload_bodythemelight__55up6, .MultipleFileUpload_bodythemedark__nDQcj {
    padding-top: 165px;
  }
}
@media (min-width: 576px) {
  .MultipleFileUpload_exer_modal_contain__hBMeo .MultipleFileUpload_modal-dialog__yUSUM {
    max-width: 1055px;
  }
  .MultipleFileUpload_delPopContainer__mSgsh .MultipleFileUpload_modal-dialog__yUSUM {
    max-width: 350px;
  }
}
.MultipleFileUpload_upload_btn__f3XcK {
  display: inline-block;
  border: 1px solid #ced4da;
  color: #60677e;
  padding: 5px 10px;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
}

.MultipleFileUpload_uploaded_imgsection__hgzcC {
  width: 100px;
  height: 150px;
}

#MultipleFileUpload_uploaded_img__okx-t {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.MultipleFileUpload_imgcancel_btn__9kFdj {
  border: none;
  font-size: 14px;
  padding: 5px 30px;
  background-color: #e2e3e7;
  margin-top: 5px;
  border-radius: 5px;
}
.MultipleFileUpload_imgcancel_btn__9kFdj:hover {
  background-color: #a9a9a9;
}

.MultipleFileUpload_close_icon_main__EdG41 {
  position: relative;
  margin-right: 1rem;
}

.MultipleFileUpload_close_icon__B8ggQ {
  position: absolute;
  right: 0px;
  border-radius: 0px 5px 0px 0px;
  width: 20px;
  height: 20px;
  background-color: #ffffff;
  border: 1px solid #ced4da;
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/MultipleFileUpload/MultipleFileUpload.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAqCA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,yBAlFO;EAmFP,kBAAA;AC1DF;;AD4DA;;;EAGE,yBAjEoB;ACQtB;;AD2DA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACxDF;;AD2DA;;CAAA;AAIA;EACE,wBAtCU;EAuCV,UAtCS;EAuCT,kBAAA;EACA,aA9CiB;EA+CjB,kBAAA;EACA,mBA1GO;EA2GP;;;GAAA;ACtDF;;AD4DA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACzDF;;AD8DA;EACE,YAAA;AC3DF;;AD8DA;EACE,sBA7FY;ACkCd;;AD8DA;;CAAA;AAGA;EACE,sBApGY;EAqGZ,iBAAA;AC3DF;;AD6DA;EACE,yBAnHgB;EAoHhB,iBAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAhHY;ACsDd;;AD6DA;EACE,yBA/HgB;ACqElB;;AD4DA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;ACzDF;;AD4DA;;CAAA;AAGA;EACE,sBAnIY;AC0Ed;;AD2DA;EACE,yBAjJgB;ACyFlB;;AD2DA;;CAAA;AAGA;EACE,yBAAA;ACxDF;;AD2DA;EACE,yBAAA;ACxDF;;AD2DA;EACE,sBAAA;ACxDF;;AD2DA;EACE,yBAlKsB;EAmKtB,WA1JY;ACkGd;;AD0DA;EACE,sCAAA;EACA,sBAAA;EACA,yBA/Lc;ACwIhB;;AD0DA;EACE,yBAAA;ACvDF;;AD0DA;EACE,sBAAA;EACA,yBAxMc;ACiJhB;;AD0DA;EACE,yBArLsB;EAsLtB,WA7KY;ACsHd;;AD0DA;;CAAA;AAGA;EACE,cAjLe;AC0HjB;;AD0DA;EACE,cArLe;AC8HjB;;AD0DA;;CAAA;AAGA;EACE,sBA/LY;EAgMZ,YAAA;ACvDF;;AD0DA;EACE,yBA/MgB;EAgNhB,WArMY;EAsMZ,YAAA;ACvDF;;ADyDA;EACE,cAtMe;ACgJjB;;ADyDA;;CAAA;AAGA;EACE,yBAhPc;EAiPd,8BAAA;ACtDF;;ADwDA;EACE,WApNY;AC+Jd;;ADuDA;;EAEE,0BAAA;ACpDF;;ADsDA;;EAEE,0BAAA;ACnDF;;ADqDA;EACE,kBAAA;AClDF;;ADoDA;EACE,kBAAA;ACjDF;;ADmDA;EACE,oCAAA;EACA,gCAAA;AChDF;;ADmDA;EACE,yBAlOkB;EAmOlB,WA3OY;AC2Ld;;ADkDA;EACE,yBAAA;AC/CF;;ADiDA;EACE,iBAAA;AC9CF;;ADgDA;;EAEE,6BAAA;AC7CF;;AD+CA;EACE,sBAxPY;AC4Md;AD8CE;EACE,yBAAA;EACA,eAAA;AC5CJ;;AD+CA;EACC,0CAAA;EACC,cA9Pe;ACkNjB;AD8CE;EACE,yCAAA;EACA,eAAA;AC5CJ;;ADgDA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,0BAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAzRY;EA0RZ,yBAAA;EACA,qDAAA;AC5CF;;AD8CA;EACE,yBAtRkB;EAuRlB,yBAAA;EACA,eAAA;AC3CF;AD6CE;EACE,cAhSa;ACqPjB;;ADgDA;;CAAA;AAGA;EACE,yBA/SgB;ACkQlB;;ADgDA;EACE,yBAAA;EACA,yBAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,yBAAA;AC5CF;;AD+CA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAlUY;ACsRd;;AD+CA;EACE,yBA9TkB;ACkRpB;;ADgDA;;CAAA;AAGA;EACE,iGAAA;EACA,sBA/UY;ACkSd;;AD+CA;EACE,mBAAA;AC5CF;;AD8CA;EACE,mBAAA;AC3CF;;AD6CA;EACE,mBAAA;AC1CF;;AD4CA;EACE,gGAAA;EACA,sBA5VY;ACmTd;;AD2CA;EACE,gGAAA;EACA,yBAAA;ACxCF;;AD0CA;EACE,mBAAA;ACvCF;;AD0CA;EACE,gGAAA;EACA,sBAxWY;ACiUd;;ADyCA;EACE,gGAAA;EACA,yBAAA;ACtCF;;ADyCA;EACE,mBAAA;ACtCF;;ADyCA;EACE,gGAAA;EACA,sBArXY;AC+Ud;;ADwCA;EACE,gGAAA;EACA,yBAAA;ACrCF;;ADuCA;EACE,mBAAA;ACpCF;;ADuCA;;;;EAIE,WAnYY;AC+Vd;;ADuCA;;CAAA;AAGA;EACE,qCAAA;ACpCF;;ADuCA;EACE,cA3Ye;ACuWjB;;ADwCA;;CAAA;AAGA;EACE,sBAAA;ACrCF;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,yBAtaqB;EAuarB,WA/ZY;AC0Xd;;ADuCA;EACE,yBA1aqB;EA2arB,WAnaY;AC+Xd;;ADuCA;EACE,6BAAA;ACpCF;;ADuCA;EACE,2BAAA;ACpCF;;ADuCA;EACE,yBAvbqB;ACmZvB;;ADuCA;EACE,WAnbY;EAobZ,6BAAA;EACA,yBAAA;ACpCF;;ADuCA;EACE,yBAjcqB;AC6ZvB;;ADwCA;EACE,yBAzcgB;ACoalB;;ADwCA;EACE,eAAA;EACA,gBAzec;EA0ed,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAvec;EAwed,gBAAA;ACrCF;;ADuCA;;;EAGE,yBA7ec;EA8ed,WA9cY;AC0ad;;ADuCA;EACE,gBAAA;EACA,YAAA;EACA,WApdY;EAqdZ,yBA3eY;EA4eZ,YAAA;EACA,eAAA;EACA,gBA9fc;AC0dhB;;ADuCA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpCF;;ADuCA;EACE,WAleY;EAmeZ,yBAzfY;EA0fZ,YAAA;ACpCF;;ADuCA;EACE,QAAA;ACpCF;;ADuCA;EACE,eAAA;EACF,eAAA;EACE,yBA7fW;EA8fX,WA/eY;EAgfZ,eAAA;EACA,gBAvhBc;EAwhBd,YAAA;ACpCF;;ADuCA;EACE,0BAAA;EACA,uBAAA;EACA,oCAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,iCAAA;ACpCF;;ADuCA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpCF;;ADuCA;EACE,kBAAA;EACA,SAAA;ACpCF;;ADuCA;;;EAGE,oCAAA;EACA,WA/gBY;EAghBZ,YAAA;ACpCF;;ADuCA;EACE,yBApjBc;ACghBhB;;ADuCA;;;EAGE,yBA1jBc;ACshBhB;;ADuCA;EACE,MAAA;ACpCF;;ADwCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;ACrCF;;ADwCA;EACE,aAAA;EACA,kBAAA;ACrCF;;ADwCA;EACE,mBAAA;ACrCF;;ADwCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ACrCF;;ADwCA;EACE,UAAA;ACrCF;;ADwCA;EACE,yBApkBqB;EAqkBrB,WA7jBY;ACwhBd;;ADwCA;EACE,UAjkBY;AC4hBd;;ADwCA;EACE,yBAhlBgB;AC2iBlB;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,6BAAA;EACA,yBAAA;EACA,WA/kBY;AC0iBd;;ADwCA;;EAEE,yBA5lBqB;EA6lBrB,WArlBY;ACgjBd;;ADuCA;EACE,6BAAA;EACA,yBAAA;EACA,WA1lBY;ACsjBd;;ADwCA;EACE;IACE,gBAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;EDuCA;IACE,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;ECrCF;EDuCA;IACE,kBAAA;ECrCF;AACF;ADwCA;EACE;IACI,iBAAA;ECtCJ;EDwCA;IACI,gBAAA;ECtCJ;AACF;AAlpBA;EACI,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AAopBJ;;AAjpBA;EACI,YAAA;EACA,aAAA;AAopBJ;;AAjpBA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAopBJ;;AAjpBA;EACI,YAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AAopBJ;AAlpBK;EACG,yBAAA;AAopBR;;AAhpBA;EACI,kBAAA;EACA,kBAAA;AAmpBJ;;AAjpBA;EACI,kBAAA;EACA,UAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;AAopBJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #205440;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #1e1e2d;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #205440;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: calc(100% - 320px);\n  position: relative;\n  left: 290px;\n  padding: 30px 30px 80px 30px;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: #F5F6FA;\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $lightthemetext !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 1rem 1rem !important;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: pointer;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: #151521;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n#card1bglight:hover {\n  background: #f7fffc;\n}\n#card1bgdark {\n  background: #392f28;\n}\n#card1bgdark:hover {\n  background: #f7fffc;\n}\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n#card2bglight:hover {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n#card3bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n#card4bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $darkTheme_updateBtn;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: auto;\npadding: 10px 0;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: auto !important;\n  height: 50px !important;\n  background-color: $primary-color !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n  padding: .375rem 1rem !important;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n.back_dlt{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $darkTheme_updateBtn; \n  color: $white-color;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $white-color;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $lightthemetext !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 998px) { \n  #dashboardcont2{\n    height: auto !important;\n  }\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 20px 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 165px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"/src/styles/Variables/Variables.scss\";\n\n.upload_btn{\n    display: inline-block;\n    border: 1px solid #ced4da;\n    color: #60677e;\n    padding: 5px 10px;\n    font-size: 14px;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n\n.uploaded_imgsection{\n    width: 100px;\n    height: 150px;\n}\n\n#uploaded_img{\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.imgcancel_btn{\n    border: none;\n    font-size: 14px;\n    padding: 5px 30px;\n    background-color: #e2e3e7;\n    margin-top: 5px;\n    border-radius: 5px;\n\n     &:hover{\n        background-color: #a9a9a9;\n     }\n}\n\n.close_icon_main{\n    position: relative;\n    margin-right: 1rem;\n}\n.close_icon{\n    position: absolute;\n    right: 0px;\n    border-radius: 0px 5px 0px 0px;\n    width: 20px;\n    height: 20px;\n    background-color: #ffffff;\n    border: 1px solid #ced4da; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `MultipleFileUpload_dashboard__njcEY`,
	"dashboardContain": `MultipleFileUpload_dashboardContain__diOti`,
	"bodythemedark": `MultipleFileUpload_bodythemedark__nDQcj`,
	"cont2": `MultipleFileUpload_cont2__AAQ9g`,
	"top_header": `MultipleFileUpload_top_header__Py0I0`,
	"top_header_inner": `MultipleFileUpload_top_header_inner__ju1dR`,
	"subLink": `MultipleFileUpload_subLink__-1y60`,
	"footer": `MultipleFileUpload_footer__BFGYL`,
	"bodythemelight": `MultipleFileUpload_bodythemelight__55up6`,
	"headerthemelight": `MultipleFileUpload_headerthemelight__MXEfp`,
	"headerthemedark": `MultipleFileUpload_headerthemedark__zXZOl`,
	"menuthemelight": `MultipleFileUpload_menuthemelight__7BXMU`,
	"menuthemedark": `MultipleFileUpload_menuthemedark__rwp8J`,
	"menulinklight": `MultipleFileUpload_menulinklight__wFWRF`,
	"menulinkdarkSelected": `MultipleFileUpload_menulinkdarkSelected__m3AHn`,
	"menulinklightSelected": `MultipleFileUpload_menulinklightSelected__D7TQn`,
	"menulinkdark": `MultipleFileUpload_menulinkdark__Q6evH`,
	"headinglight": `MultipleFileUpload_headinglight__EKOr6`,
	"headingdark": `MultipleFileUpload_headingdark__qVnHy`,
	"searchboxlight": `MultipleFileUpload_searchboxlight__RYStC`,
	"searchboxdark": `MultipleFileUpload_searchboxdark__ATbCI`,
	"tableheadlight": `MultipleFileUpload_tableheadlight__IICSt`,
	"tableheaddark": `MultipleFileUpload_tableheaddark__uDmqr`,
	"table": `MultipleFileUpload_table__tyXPa`,
	"table-borderless": `MultipleFileUpload_table-borderless__aRKlG`,
	"left-section": `MultipleFileUpload_left-section__ZDD+g`,
	"tablebodylight": `MultipleFileUpload_tablebodylight__+2kEF`,
	"tablebodydark": `MultipleFileUpload_tablebodydark__OQqHb`,
	"paginationlight": `MultipleFileUpload_paginationlight__suIRL`,
	"paginationdark": `MultipleFileUpload_paginationdark__z0Qbk`,
	"formthemelight": `MultipleFileUpload_formthemelight__cDiE-`,
	"formthemedark": `MultipleFileUpload_formthemedark__4dyQi`,
	"viewformlight": `MultipleFileUpload_viewformlight__LkUc8`,
	"permissionboxlight": `MultipleFileUpload_permissionboxlight__pZ+zL`,
	"permissionboxdark": `MultipleFileUpload_permissionboxdark__6GAme`,
	"errormsgclr": `MultipleFileUpload_errormsgclr__cG9yB`,
	"graphclrlight": `MultipleFileUpload_graphclrlight__n2Sr4`,
	"graphclrdark": `MultipleFileUpload_graphclrdark__2W8YW`,
	"card1bglight": `MultipleFileUpload_card1bglight__C3eeB`,
	"card1bgdark": `MultipleFileUpload_card1bgdark__A+GqH`,
	"card2bglight": `MultipleFileUpload_card2bglight__o-SOh`,
	"card2bgdark": `MultipleFileUpload_card2bgdark__J+NKA`,
	"card3bglight": `MultipleFileUpload_card3bglight__1SGnR`,
	"card3bgdark": `MultipleFileUpload_card3bgdark__X-HBK`,
	"card4bglight": `MultipleFileUpload_card4bglight__1+fiS`,
	"card4bgdark": `MultipleFileUpload_card4bgdark__VCeGa`,
	"actionbtnlight": `MultipleFileUpload_actionbtnlight__toXE9`,
	"actionbtndark": `MultipleFileUpload_actionbtndark__tt7mR`,
	"profiledropdownlight": `MultipleFileUpload_profiledropdownlight__kVfq-`,
	"profiledropdowndark": `MultipleFileUpload_profiledropdowndark__XT0PU`,
	"settingsection": `MultipleFileUpload_settingsection__wRS3o`,
	"addform": `MultipleFileUpload_addform__TioPc`,
	"savebtn": `MultipleFileUpload_savebtn__E3H6v`,
	"profile_conatiner": `MultipleFileUpload_profile_conatiner__5MRJz`,
	"ag-theme-alpine": `MultipleFileUpload_ag-theme-alpine__dmLs-`,
	"ag-row": `MultipleFileUpload_ag-row__jVeoB`,
	"formbtn": `MultipleFileUpload_formbtn__IMFTv`,
	"resetbtn": `MultipleFileUpload_resetbtn__JOibc`,
	"addBtn": `MultipleFileUpload_addBtn__XN+ey`,
	"cust_addBtn": `MultipleFileUpload_cust_addBtn__mbp2P`,
	"deleteBtn": `MultipleFileUpload_deleteBtn__Cthuu`,
	"confirmBtn": `MultipleFileUpload_confirmBtn__Hu73W`,
	"back_dlt": `MultipleFileUpload_back_dlt__LqR+c`,
	"delPopContainer": `MultipleFileUpload_delPopContainer__mSgsh`,
	"modal-body": `MultipleFileUpload_modal-body__ZaTVw`,
	"delet_icon": `MultipleFileUpload_delet_icon__rCiDT`,
	"arrowback": `MultipleFileUpload_arrowback__uE5pT`,
	"drpdwn_btn": `MultipleFileUpload_drpdwn_btn__FUvyA`,
	"empname": `MultipleFileUpload_empname__N-SE-`,
	"navitemli": `MultipleFileUpload_navitemli__UiPob`,
	"tabnavli": `MultipleFileUpload_tabnavli__y6GNL`,
	"settingsgeneral": `MultipleFileUpload_settingsgeneral__7QqqL`,
	"settingslinks": `MultipleFileUpload_settingslinks__tlKBP`,
	"dashboardcont2": `MultipleFileUpload_dashboardcont2__EknEY`,
	"sectionright": `MultipleFileUpload_sectionright__PRP6W`,
	"exer_modal_contain": `MultipleFileUpload_exer_modal_contain__hBMeo`,
	"modal-dialog": `MultipleFileUpload_modal-dialog__yUSUM`,
	"upload_btn": `MultipleFileUpload_upload_btn__f3XcK`,
	"uploaded_imgsection": `MultipleFileUpload_uploaded_imgsection__hgzcC`,
	"uploaded_img": `MultipleFileUpload_uploaded_img__okx-t`,
	"imgcancel_btn": `MultipleFileUpload_imgcancel_btn__9kFdj`,
	"close_icon_main": `MultipleFileUpload_close_icon_main__EdG41`,
	"close_icon": `MultipleFileUpload_close_icon__B8ggQ`
};
export default ___CSS_LOADER_EXPORT___;
